'use client'

import { useState } from 'react'
import { IconInfoCircleFilled } from '@tabler/icons-react'

import { Collapse } from 'shared/ui/Collapse'
import { Tooltip } from 'shared/ui/Tooltip'
import { isNotNilOrEmpty } from 'shared/utils/ramda'
import { addTestId } from 'shared/utils/tests'

import { ProductTypes } from '../../../types/products'
import { getProductPrices } from '../../../utils/products'
import { multiplyingPriceByQuantityJump } from '../../../utils/quantity'

import styles from './ProductCardPrices.module.scss'

interface ProductCardPricesProps {
  product: ProductTypes
  quantityJump: number
  isHovered?: boolean
  size?: 'small' | 'large'
}

const ProductCardPrices = ({
  product,
  quantityJump,
  isHovered
}: ProductCardPricesProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const { currentPrice, lowestPrice30days, promoPrice, defaultPrice } =
    getProductPrices(product)

  const productTooltipHelper = `${
    isNotNilOrEmpty(lowestPrice30days) ? '*' : ''
  }`

  const handleTooltipOpen = () => setTooltipOpen(true)
  const handleTooltipClose = () => setTooltipOpen(false)

  return (
    <div className={styles.buyingContent}>
      <div className={styles.price}>
        <p
          className={styles.currentPrice}
          dangerouslySetInnerHTML={{
            __html: `${multiplyingPriceByQuantityJump(
              currentPrice,
              quantityJump
            )} ${productTooltipHelper}`
          }}
          {...addTestId('product-card-current-price')}
        />
        {isNotNilOrEmpty(promoPrice) && (
          <p
            className={styles.oldPrice}
            dangerouslySetInnerHTML={{
              __html: `${multiplyingPriceByQuantityJump(
                defaultPrice,
                quantityJump
              )}`
            }}
            {...addTestId('product-card-old-price')}
          />
        )}
      </div>
      {isNotNilOrEmpty(lowestPrice30days) && (
        <>
          <Collapse open={!!isHovered}>
            <div className={styles.lowestPrice}>
              <Tooltip
                id={`product-card-lowest-price-tooltip-${product.id}`}
                onClose={handleTooltipClose}
                open={tooltipOpen}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title='Najniższa cena produktu z ostatnich 30 dni, przed zastosowaniem promocji.'
              >
                <div className={styles.iconWrapper}>
                  <IconInfoCircleFilled onClick={handleTooltipOpen} size='18' />
                </div>
              </Tooltip>
              <p>
                Najniższa cena z 30 dni przed obniżką{' '}
                <span
                  {...addTestId('product-card-lowest-price')}
                  dangerouslySetInnerHTML={{
                    __html: lowestPrice30days || ''
                  }}
                />
              </p>
            </div>
          </Collapse>
        </>
      )}
    </div>
  )
}

export default ProductCardPrices
